define('plugin/invoice/view/InvoicePaymentView',['require','lib/view/LayoutView','Config','lib/LoadWithNonce'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');
    var loadWithNonce = require('lib/LoadWithNonce');

    /**
     * Payment process view
     *
     * @class InvoicePaymentView
     */
    return LayoutView.extend({

        template: '#invoice_payment_view',
        ui: {
            'container': '#sb_invoice_payment_container'
        },

        _invoiceModel: null,
        _paymentSystemModel: null,

        initialize: function () {
            this._invoiceModel = this.getOption('invoiceModel');
            this._paymentSystemModel = this.getOption('paymentSystemModel');
        },

        onShow: function () {
            if (!this._paymentSystemModel.get('storedPaymentMethod')) {
                var recurring = '';
                if (this._paymentSystemModel.get('recurring')) {
                    recurring = '/recurring/1/';
                }
                var rebilling = '';
                if (this._paymentSystemModel.get('rebilling')) {
                    rebilling = '/rebilling/1/';
                }

                var params = '';
                if (Config.getInstance().getOption('widget_type')) {
                    // provided by the server: the query of the current url is not kept by in-app navigation
                    var hostUrl = Config.getInstance().getOption('host_url') ||
                        new URLSearchParams(window.location.search).get('host_url');
                    params = '?is-widget=1' + (hostUrl ? '&host_url=' + encodeURIComponent(hostUrl) : '');
                }

                var url = '/v2/ext/invoice-payment/pay/system/' + this._paymentSystemModel.get('payment_system') + '/invoice_id/' + this._invoiceModel.get('id') + recurring + rebilling + params;

                $.ajaxSetup({
                    cache: true
                });
                var instance = this;
                loadWithNonce(this.ui.container, url, function () {
                    // Redirect-style responses (e.g. SBPay) render a marker instead of an inline
                    // <script>, so the top-window navigation happens here rather than via jQuery's
                    // globalEval (which would need 'unsafe-eval' — blocked under csp_strict_eval).
                    var $redirect = instance.ui.container.find('.sb-payment-redirect');
                    if ($redirect.length && $redirect.data('url')) {
                        window.top.location.href = $redirect.data('url');
                        return;
                    }
                    instance.triggerMethod('payment_processor:loaded', instance._paymentSystemModel);
                });
            } else {
                var _this = this;
                this._invoiceModel.pay(this._paymentSystemModel.get('id'), this._paymentSystemModel.get('recurring')).then(function () {
                    Backbone.history.navigate('invoice/pay/' + _this._invoiceModel.get('id') + '/return/1', {trigger: true});
                });
            }

        }

    });

});
